import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const syncDevicesEndpoint = (cloudId: string, values: string[]) =>
	performPostRequest<unknown>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences/sync-devices`,
		{
			body: JSON.stringify({ values }),
		},
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'syncDevicesEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
